module.exports = __webpack_public_path__ + "img/terroir-disc-1-mobile.31d093e3.jpg";